/**
 * editCartController - used for cart edit functionality. E.g. editing rooms in mobi cart
 */
bookingApp.controller('editCartController', function($scope, $routeParams, propertyFactory, sessionFactory){
    $scope.editingRoom = true;
    $scope.editingRoomId = $routeParams.id;
    // reset the photo being viewed
    $scope.session.viewingPhoto = 0;
    // setup the room being viewed id
    $scope.session.viewingRoom = $scope.cart.rooms[$routeParams.id].id;

    // setup footer
    $scope.setupStandardCartFooter();
    $scope.footer.display.next = false;

    // set the pax configuration
    // $scope.session.selectedRoom.selectedAdults = $scope.cart.rooms[$routeParams.id].paxConfig.adults;
    $scope.session.selectedRoom.selectedAdults = cart.getGroupAdults($scope.cart.rooms[$routeParams.id].roomGroupIndex);
    // $scope.session.selectedRoom.selectedChildren = $scope.cart.rooms[$routeParams.id].paxConfig.children;
    $scope.session.selectedRoom.selectedChildren = cart.getGroupChildren($scope.cart.rooms[$routeParams.id].roomGroupIndex);
    // $scope.session.selectedRoom.selectedInfants = $scope.cart.rooms[$routeParams.id].paxConfig.infants;
    $scope.session.selectedRoom.selectedInfants = cart.getGroupInfants($scope.cart.rooms[$routeParams.id].roomGroupIndex);

    $scope.session.selectedRoom.customFields = $scope.cart.rooms[$routeParams.id].paxConfig.customFields;
    $scope.session.selectedRoom.roomDetails = $scope.cart.rooms[$routeParams.id].roomDetails;
    // setup the viewed Room
    $scope.viewedRoom = $scope.property.rooms[$scope.session.viewingRoom];
    $scope.session.selectedRoom.maxPax = $scope.viewedRoom.bookable.maxPax;

    $scope.savedPax = _.reduce({
        adults: $scope.session.selectedRoom.selectedAdults || 0,
        children: $scope.session.selectedRoom.selectedChildren || 0,
        infants: $scope.session.selectedRoom.selectedInfants || 0
    }, function(a, b) { return a + b });

    // update the sessionFactory.selectedRoom -> this needs to have the max pax reset based on the room availability * maxPax.
    if($scope.viewedRoom.rate.isPaxRate) {
        sessionFactory.selectedRoom.maxPax = sessionFactory.selectedRoom.maxPax * (propertyFactory.roomAvailabilities[$scope.viewedRoom.nonFilteredIndex].availableRooms + $scope.savedPax);
    }

    // pax option array creator
    $scope.getOptionArray = function(type){
        var selected = 0;
        switch(type){
            case "adults":
                selected = $scope.session.selectedRoom.remainingPax.adults;
                break;
            case "children":
                selected = $scope.session.selectedRoom.remainingPax.children;
                break;
            case "infants":
                selected = $scope.session.selectedRoom.remainingPax.infants;
                break;
        }
        var num = selected+1;
        return new Array(parseInt(num));
    };

    // get the pricing
    $scope.calculatePricing = function(){
        var prices = $scope.property.prices[$scope.session.viewingRoom];
        var adults = $scope.session.selectedRoom.selectedAdults;
        var children = $scope.session.selectedRoom.selectedChildren;
        var infants = $scope.session.selectedRoom.selectedInfants;
        var paxConfig = RoomRatePricing.buildPaxConfiguration(adults, children, infants);
        var start = $scope.session.selectedFilters.checkin;
        var end = $scope.session.selectedFilters.checkout;
        var range = moment.range(start, end);
        var period = 'nights';
        if(propertyFactory.rooms[sessionFactory.viewingRoom].rate.isPaxRate){
            var paxConfig = paxConfigurationCalculator.buildPaxConfiguration(adults,children,infants);
            var maxPaxConfig = propertyFactory.rooms[sessionFactory.viewingRoom].maxPaxComponents;
            var infantsTakeAvailability = propertyFactory.rooms[sessionFactory.viewingRoom].bookable.infantsTakeAvail;
            var roomConfigs = paxConfigurationCalculator.getRoomConfiguration(paxConfig, maxPaxConfig, infantsTakeAvailability);
            // calculate the pricing based on the room configuration
            var total = 0;
            angular.forEach(roomConfigs, function(roomConfig){
                var priceOb = RoomRatePricing.getPerPeriodAndTotalPrice(prices, roomConfig, range, period);
                total += priceOb.total;
            });
            sessionFactory.viewingRoomPrice = total;
        } else {
            var priceOb = RoomRatePricing.getPerPeriodAndTotalPrice(prices, paxConfig, range, period);
            $scope.session.viewingRoomPrice = priceOb.total;
        }
        // calculate the pricing based on the pax config
    };

    // watcher for pax configuration
    $scope.$watch('session.selectedRoom', function(){
        $scope.session.selectedRoom.selectedAdults = parseInt($scope.session.selectedRoom.selectedAdults);
        $scope.session.selectedRoom.selectedChildren = parseInt($scope.session.selectedRoom.selectedChildren);
        $scope.session.selectedRoom.selectedInfants = parseInt($scope.session.selectedRoom.selectedInfants);
        // use the configuration checker js object
        // get max values
        var maxAdults = $scope.viewedRoom.rate.basePax + $scope.viewedRoom.rate.maxAdditionalPax;
        var maxChildren = (typeof $scope.viewedRoom.rate.childRate !== 'undefined') ? ($scope.viewedRoom.rate.childRate.basePax + $scope.viewedRoom.rate.childRate.maxAdditionalPax) : $scope.session.selectedRoom.maxPax;
        var maxInfants = (typeof $scope.viewedRoom.rate.infantRate !== 'undefined') ? ($scope.viewedRoom.rate.infantRate.basePax + $scope.viewedRoom.rate.infantRate.maxAdditionalPax) : $scope.session.selectedRoom.maxPax;
        var infantTakesAvailability = $scope.viewedRoom.bookable.infantsTakeAvail;
        if($scope.viewedRoom.rate.isPaxRate) {
            maxAdults = $scope.session.selectedRoom.maxPax *
                // (
                    ($scope.property.roomAvailabilities[$scope.viewedRoom.nonFilteredIndex].availableRooms > 0 ?
                    $scope.property.roomAvailabilities[$scope.viewedRoom.nonFilteredIndex].availableRooms : 1)
                    // + $scope.savedPax)
                ;
            maxChildren = maxAdults;
            maxInfants = infantTakesAvailability ? maxAdults : 15;
        }
        var maxPaxConfigOb = configurationChecker.generateMaxPaxConfigObject($scope.session.selectedRoom.maxPax, maxAdults, maxChildren, maxInfants, true, true, infantTakesAvailability);
        var incrementConfigOb = configurationChecker.generateIncrementPaxObject($scope.session.selectedRoom.selectedAdults, $scope.session.selectedRoom.selectedChildren, $scope.session.selectedRoom.selectedInfants);
        var configOutput = configurationChecker.updateMaxPax(maxPaxConfigOb, incrementConfigOb);
        // setup the remaining pax values
        $scope.session.selectedRoom.remainingPax = {};
        $scope.session.selectedRoom.remainingPax.adults = configOutput.available.adults;
        $scope.session.selectedRoom.remainingPax.children = configOutput.available.children;
        $scope.session.selectedRoom.remainingPax.infants = configOutput.available.infants;
        // update the pax remaining
        $scope.session.selectedRoom.remainingPax.overall = $scope.session.selectedRoom.maxPax - ($scope.session.selectedRoom.selectedAdults + $scope.session.selectedRoom.selectedChildren + ($scope.viewedRoom.bookable.infantsTakeAvail ? $scope.session.selectedRoom.selectedInfants : 0));
        // re-calculate the pricing
        $scope.calculatePricing();
    }, true);

    // remove the room
    $scope.removeRoomBackToCart = function(){
        $scope.removeRoom($routeParams.id, false);
        $scope.goBack();
    };

    // update the room with the pax changes
    $scope.updateRoom = function(){

        if(propertyFactory.rooms[$scope.cart.rooms[$routeParams.id].id].rate.isPaxRate){
            // drop the previously added rooms to the cart and add the new ones.
            $scope.removeRoom($routeParams.id, true);
            $scope.addPaxedRoomsToCart();
            // Increase the group number
            sessionFactory.roomGroupIndex++;
        } else {
            // check pax configurations has any pax added
            if (!$scope.checkPax()) {
                return false;
            }
            $scope.cart.rooms[$routeParams.id].paxConfig.adults = $scope.session.selectedRoom.selectedAdults;
            $scope.cart.rooms[$routeParams.id].paxConfig.children = $scope.session.selectedRoom.selectedChildren;
            $scope.cart.rooms[$routeParams.id].paxConfig.infants = $scope.session.selectedRoom.selectedInfants;
            $scope.cart.rooms[$routeParams.id].customFields = $scope.session.selectedRoom.customFields;
        }
        $scope.goBack();
        return true;
    };
});
